<template>
  <div
    :class="['verify', !disabled ? '-center' : '']">
    <div>
      <p class="heading">
        {{ content.heading }}
      </p>
      <template v-if="disabled">
        <div class="sections mt-12">
          <p>{{ $t('pages.onboarding.business.company_details.verify.tooltip.disabled.sections') }}:</p>
          <ul
            v-if="emptySections.length"
            class="text-red-main">
            <li
              v-for="(section) in emptySections"
              :key="section.label">
              {{ $t(section.label) }} section
            </li>
          </ul>
        </div>
      </template>
    </div>
    <AppButton
      type="primary"
      size="medium"
      :disabled="disabled"
      class="colored"
      @click="open">
      {{ content.button }}
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import type { Action } from 'element-plus';
import { ElMessageBox } from 'element-plus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import AppButton from '@/components/ui-framework/app-button.vue';
import { translateKeys } from '@/i18n/translate';

const emits = defineEmits(['submit']);
const { disabled, sections, customerType } = defineProps<{ disabled?: boolean; sections: string[]; customerType: 'company' | 'customer' }>();
const i18n = useI18n();

const content = computed(() => {
  const KeyName = {
    heading: disabled
      ? 'pages.onboarding.business.company_details.verify.tooltip.disabled.heading'
      : 'pages.onboarding.business.company_details.verify.tooltip.heading',
    button: 'pages.onboarding.business.company_details.verify.tooltip.button',
  };
  return translateKeys([
    { name: 'heading', key: KeyName.heading },
    { name: 'button', key: KeyName.button },
  ], { customer: customerType });
});

const open = () => {
  ElMessageBox.alert(
    i18n.t('pages.onboarding.business.verification.tip'),
    i18n.t('pages.onboarding.business.verification.heading'),
    {
      showCancelButton: true,
      confirmButtonText: i18n.t('action.verify'),
      cancelButtonText: i18n.t('action.cancel'),
      cancelButtonClass: '1',
      confirmButtonClass: 'btn--primary',
      callback: (action: Action) => {
        if (action === 'confirm') {
          emits('submit');
        }
      },
    },
  );
};

type ISection = { label: string };

const emptySections = computed(() => sections.map((label) => ({ label })) as ISection[]);
</script>

<style lang="scss" scoped>
.verify {
  background-color: #fef5eb;
  border-radius: 12px;
  @apply flex justify-between px-24 py-16 mb-24 w-[708px];

  &.-center {
    align-items: center;
  }

  .heading {
    font-size: 14px;
    font-weight: 500;
    max-width: 420px;
  }

  button:disabled {
    opacity: 0.4;
  }

  .sections {
    font-size: 12px;
    font-weight: 500;

    ul {
      list-style-type: disc;
      margin-left: 20px;
    }
  }
}
</style>
